import React from 'react';
import { useUtilitiesCompany } from '../context/UtilitiesCompanyContext';

/**
 * Page frame for every Utilities screen: title, company picker and an
 * optional action area. Company choice applies to all calls on the page.
 */
export default function UtilitiesShell({ title, subtitle, actions, children }) {
  const { companies, companyId, setCompanyId } = useUtilitiesCompany();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        <div className="flex flex-wrap items-center gap-3">
          {companies.length > 1 && (
            <label className="flex items-center gap-2 text-sm text-slate-600">
              <span>Company</span>
              <select
                value={companyId ?? ''}
                onChange={(e) => setCompanyId(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm"
              >
                {companies.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </label>
          )}
          {companies.length === 1 && (
            <span className="text-sm text-slate-600">{companies[0].name}</span>
          )}
          {actions}
        </div>
      </div>
      {children}
    </div>
  );
}

export function UtilitiesBanner({ tone = 'error', children }) {
  const styles =
    tone === 'error'
      ? 'bg-red-50 text-red-800 border-red-200'
      : tone === 'success'
        ? 'bg-green-50 text-green-800 border-green-200'
        : 'bg-slate-50 text-slate-700 border-slate-200';
  return (
    <div className={`mb-4 rounded-lg border px-4 py-3 text-sm ${styles}`} role={tone === 'error' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
